import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { PrescriptionState } from './state';

const defaultState: PrescriptionState = {
  prescriptions: [],
  patients: [],
};

export const prescriptionModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
